import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { Box, Link } from '@mui/material';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../types';
import { GipStationsField_v1 } from './stations-field/GipStationsFieldV1';
import { GipStationsField_v2 } from './stations-field/GipStationsFieldV2';

export const GipStationsField = () => {
  const { $t } = useIntl();
  const { values, setFieldValue } = useFormikContext<GipReportValues>();

  const currentSelectionType = values.stationsSelectionType || 'advanced';
  const isAdvanced = currentSelectionType === 'advanced';

  const handleToggleSelectionType = () => {
    const newType = isAdvanced ? 'simple' : 'advanced';
    setFieldValue('stationsSelectionType', newType);
  };

  // allow both filters if the feature flag is not enabled
  const allowBothFilters = useFeatureIsOn('app__audit_reports_advanced_stations_filter') !== true;

  return (
    <>
      <Box>{isAdvanced ? <GipStationsField_v2 /> : <GipStationsField_v1 />}</Box>
      {allowBothFilters && (
        <Box mt={-2.5} mb={2}>
          <Link
            component="button"
            variant="body2"
            onClick={handleToggleSelectionType}
            sx={{ textDecoration: 'none', cursor: 'pointer' }}
          >
            {isAdvanced
              ? $t({
                  id: 'audit.gipReport.form.switchToSimpleStationsFilter',
                  defaultMessage: 'Usar filtro simple',
                })
              : $t({
                  id: 'audit.gipReport.form.switchToAdvancedStationsFilter',
                  defaultMessage: 'Usar filtro avanzado',
                })}
          </Link>
        </Box>
      )}
    </>
  );
};
